export default [
    {
      path: "/windrow-registration",
      component: () => import("../layout/PageLayoutWithoutContainer.vue"),
      children: [
        {
          path: "",
          name: "Windrow Registration",
          component: () => import("@/views/WindrowRegistration/WindrowRegistration.vue"),
        }
      ]
    }
];
  